import feedbacks from './feedbacks';
import rules from './rules';

(function () {
  'use strict';

  window.permissions = {
    // As permissões estão dispostas na ordem que elas devem ser testadas pelo script, devido a perfomance.
    // Dessa forma garante-se que o feedback seguirá a mesma sequência que o fluxo de criação de conta do usuário.
    _available: [
      'account',
      'confirmed_account',
      'trial',
      'trialAndStandard',
      'subscription',
      'premium',
      'black',
      'unlimited',
      'digital_unlimited',
      'judicial',
      'judicial_unlimited',
      'unlimited_qc',
      'elite',
      'commented_feedback_enabled'
    ],

    feedbacks: feedbacks,

    start() {
      this.bindClicks();
    },

    prepare(permissions) {
      return permissions.sort((a, b) => {
        return this._available.indexOf(a) - this._available.indexOf(b);
      });
    },

    hasPermissions(permissions, proceed = true, reason = null) {
      this.prepare(permissions).every(permission => {
        if (!rules[permission]) {
          throw new Error(`The rule "${permission}" does not exists!`);
        }

        proceed = rules[permission]();
        reason = proceed ? null : permission;

        return proceed;
      });

      return { proceed, reason };
    },

    bindClicks() {
      $(document)
        .off('click.permissions')
        .on('click.permissions', '[data-permissions]', event => {
          const data = $(event.currentTarget).data();
          const permissions = data.permissions.split(',');

          const { proceed, reason } = this.hasPermissions(permissions);

          if (proceed && data.redirect) {
            event.preventDefault();
            Turbolinks.visit(data.redirect);
            return;
          }

          if (!proceed) {
            const url =
              data.redirect || `${location.pathname}${location.search}`;
            this.feedbacks[reason](event, url, data);
          }
        });
    }
  };

  $(document).on('turbolinks:load', () => {
    window.permissions.start();
  });

  window.permissions.start();
})();
